import { action, computed, observable } from 'mobx';
import React from 'react';
import Status from '../../constants/Status';
import ConfigRepository from '../../repositories/ConfigRepository';
import KlarnaRepository from '../../repositories/KlarnaRepository';
import TransactionRepository from '../../repositories/TransactionRepository';

interface IKlarnaMessagingViewControllerConfig {
  klarnaRepository: KlarnaRepository;
  configRepository: ConfigRepository; 
  transactionRepository: TransactionRepository;
}

interface KlarnaMessagingViewControllerData {
  klarnaHtmlContent: string;
  status: Status;
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  isKlarnaMessageAvailable: boolean;
}

export default class KlarnaMessagingViewController extends React.Component<IKlarnaMessagingViewControllerConfig> {
  private transactionRepository: TransactionRepository;

  private klarnaRepository: KlarnaRepository;
  
  @observable private isOpen = false;

  constructor(config: IKlarnaMessagingViewControllerConfig) {
    super(config);
    this.klarnaRepository = config.klarnaRepository;
    this.transactionRepository = config.transactionRepository;
  }

  @action
  openModal = (): void => {
    this.isOpen = true;
  };
  
  @action
  closeModal = (): void => {
    this.isOpen = false;
  };

  async loaded(): Promise<void> {
    await this.klarnaRepository.loadKlarnaModalHtmlContent();
    await this.transactionRepository.getTransaction();
  }

  @computed
  get data(): KlarnaMessagingViewControllerData {
    return {
      closeModal: this.closeModal,
      isKlarnaMessageAvailable: this.isKlarnaMessageAvailable,
      isOpen: this.isOpen,
      klarnaHtmlContent: this.klarnaModalFormattedContent,
      openModal: this.openModal,
      status: this.klarnaRepository.status,
    };
  }

  @computed
  get isKlarnaMessageAvailable(): boolean {
    return this.transactionRepository.transaction?.payment.adyenKlarnaPaymentEligible;
  }

  @computed
  get klarnaModalFormattedContent(): string {
    const { klarnaHtmlContent } = this.klarnaRepository;
    return klarnaHtmlContent;
  }
}
